import { getServerResponse, randomString, getPostServerResponse, ImageToBase64, setCookie, deleteCookie, checkCookie } from '../functions'
import { localStorage } from '../functions/AsyncStorage'
import { action, global } from '../const'
import { exceptionHandler } from '.'
import { getCurrentLanguage } from './Main'
let isSignin = false

export const updateAuthState = (payload) => {
  return {
    type: action.UPDATE_AUTH_STATE,
    payload
  }
}

export function checkWebAuth () {
  return (dispatch, getState) => {
    const { userInfo } = getState().auth
    if (userInfo) {
      return true
    }
    const autoLogin = checkCookie(global.IS_REMEMBER)
    if (!autoLogin) {
      dispatch({ type: action.USER_LOGOUT })
      return false
    };
    const res = window.localStorage.getItem(global.USERINFO)
    if (res && res !== null) {
      dispatch(getCurrentLanguage())
      const userInfo = JSON.parse(res)
      dispatch({
        type: action.SET_LOGIN_USER,
        payload: userInfo
      })
      let WEStatus = false
      if (userInfo.we_switch === 1 || userInfo.we_switch === '1') WEStatus = true
      dispatch({ type: action.IS_ENGLISH_ENABLE, status: WEStatus })
      dispatch({ type: action.IS_REMEMBER_ME })
      return true
    } else {
      // dispatch({ type: action.USER_LOGOUT })
      return false
    }
  }
}

export const getInvitationDetails = (inviteId) => {
  return async (dispatch) => {
    try {
      if (dispatch(checkWebAuth()) === true) dispatch(logoutUser())
      const response = await getServerResponse({
        cmd: 'WoogiConnectInvite.getInviteDataByKey',
        key: inviteId
      })
      if (response.error) return
      dispatch(updateAuthState({ invitedUser: response }))
    } catch (error) {
      exceptionHandler('getInvitationDetails', error)
    }
  }
}

export const getUserPersonalDetails = () => {
  return async (dispatch, getState) => {
    let { userInfo } = getState().auth
    try {
      const response = await getServerResponse({ cmd: 'WcnUser1.getUserData', token: (userInfo.token || '') })
      if (response.error) return
      const imgBase64 = await ImageToBase64(global.MAKEURL(response.avatar))
      userInfo = Object.assign({}, userInfo, response, { avatar: imgBase64 })
      localStorage(1, global.USERINFO, userInfo)
      return dispatch(updateAuthState({ userInfo }))
    } catch (error) {

    }
  }
}

export const checkUsername = (username) => {
  return new Promise(async (resolve) => {
    const progress = 0; let message = 'length of username is invalid, should be less than 16 chars and more than 6 chars.'; let validUsername = []
    try {
      const response = await getServerResponse({ cmd: 'WcnUser1.checkUserName', username })
      if (response.error) resolve({ status: 0, message, validUsername })

      if (response.status === 1) message = null
      else if (response.status === 2) {
        validUsername = response.suggest_names
        message = 'User name exists.'
      } else if (response.status === 3) message = 'Abuse detected in name sting.'
      else if (response.status === 0) { message = 'length of username is invalid, should be less than 16 chars and more than 6 chars.' }
      resolve({ status: response.status, message, validUsername })
    } catch (error) {
      resolve({ status: 0, progress, message })
    }
  })
}

export const passwordValidate = (password) => {
  return new Promise(async (resolve) => {
    let progress = 0; let message = 'Must be a minimum of 8 characters and hard for robots to guess.'
    try {
      const response = await getServerResponse({ cmd: 'WcnUser1.checkPassword', password })
      if (response.error) resolve({ status: 1, progress, message })
      if (response === 200) {
        if (password.length >= 4) progress = 3
        if (password.length >= 6) progress = 4
        if (password.length >= 8) progress = 5
        message = null
      }
      if (response === 2) message = 'empty space is not allowed in password string'
      resolve({ status: response, progress, message })
    } catch (error) {
      resolve({ status: 1, progress, message })
    }
  })
}

export const userRegister = (registerFbUser = undefined) => {
  return async (dispatch, getState) => {
    let { registerUser } = getState().auth
    try {
      dispatch({ type: action.LOADING_DIALOG_TRUE })
      dispatch({ type: action.IS_REMEMBER_ME })
      const { APP_NAME, APP_KEY, AppVersion, APP_PLATFORM } = global
      if (registerFbUser) registerUser = registerFbUser
      const request = {
        cmd: 'WcnUser1.register',
        app: APP_NAME,
        app_key: APP_KEY,
        version: AppVersion,
        platform: APP_PLATFORM(),
        ...registerUser
      }
      const response = await getServerResponse(request)
      console.log(response)
      if (response === 200) {
	
	let userStatus

	if(registerUser.fb_id)
	{ // we have facebook id avaiable
		userStatus = await dispatch(loginByFaceBook({ fb_id: registerUser.fb_id, email: registerUser.security_email }))
	}
	else
	{ // we use normal login
		userStatus = await dispatch(userSignIn({ name: registerUser.username, password: registerUser.password }))
	}

        //const userStatus = await dispatch(loginByFaceBook({ fb_id: registerUser.fb_id, email: registerUser.security_email }))

        dispatch({ type: action.LOADING_DIALOG_FALSE })
        return userStatus
      }
      dispatch({ type: action.LOADING_DIALOG_FALSE })
      return { status: 403, message: 'User is not valiad, please check information and try again.' }
    } catch (error) {
      dispatch({ type: action.LOADING_DIALOG_FALSE })
      console.log(error)
      return { status: 403, message: "We can't process your request!" }
    }
  }
}

export const userAppleRegister = (registerUser) => {
  return async (dispatch) => {
    try {
      dispatch({ type: action.LOADING_DIALOG_TRUE })
      dispatch({ type: action.IS_REMEMBER_ME })
      const { APP_NAME, APP_KEY, AppVersion, APP_PLATFORM } = global
      const request = {
        cmd: 'WcnUser1.register2',
        app: APP_NAME,
        app_key: APP_KEY,
        version: AppVersion,
        platform: APP_PLATFORM(),
        ...registerUser
      }
      const response = await getServerResponse(request)
      console.log(response)
      if (response === 200) {
        const userStatus = await dispatch(userAppleSignIn({
          apple_id: registerUser.apple_id,
          authorizationCode: registerUser.authorizationCode,
          identityToken: registerUser.identityToken
        }))
        dispatch({ type: action.LOADING_DIALOG_FALSE })
        return userStatus
      }
      dispatch({ type: action.LOADING_DIALOG_FALSE })
      if (response === 407 || response === '407') return { status: 403, message: 'apple account already register, please again with login.' }
      return { status: 403, message: 'User is not valiad, please check information and try again.' }
    } catch (error) {
      dispatch({ type: action.LOADING_DIALOG_FALSE })
      console.log(error)
      return { status: 403, message: 'Oops! Something is wrong' }
    }
  }
}

export const userSignIn = (data) => {
  return async (dispatch, getState) => {
    const { invitedUser, isRemember } = getState().auth
    try {
      const sequence_id = await getServerResponse({ cmd: 'User1.preLogin', name: data.name })
      const device_id = randomString(32)
      let request = {
        cmd: 'User1.login1',
        app: global.APP_NAME,
        app_key: global.APP_KEY,
        version: global.AppVersion,
        platform: global.APP_PLATFORM()
      }
      request = { ...request, ...data, sequence_id, device_id }

      const response = await getServerResponse(request)
      if (response === 404) return { status: 403, message: 'Incorrect username or password!' }
      if (response.error) return { status: 403, message: "We can't process your request!" }
      if (response.error_state === 0) {
        let userInfo = response
        let invited = false
        dispatch({ type: Number(userInfo.we_switch) === 1 ? action.IS_ENGLISH_ENABLE : action.IS_ENGLISH_DISABLE })
        if (invitedUser && invitedUser !== 404) {
          if (invitedUser.family_name || invitedUser.role_type) {
            const invitation = {
              cmd: 'WoogiConnectIdentity.joinFamily',
              user_id: userInfo.id,
              identity: invitedUser.role_type,
              family_name: invitedUser.family_name
            }
            const status = await getServerResponse(invitation)
            if (status === 200) invited = true
          }
        }
        userInfo = { ...userInfo, device_id, password: data.password }
        localStorage(1, global.USERINFO, userInfo)
        dispatch({
          type: action.SET_LOGIN_USER,
          payload: userInfo
        })
        if (isRemember && !global.isNative) setCookie(global.IS_REMEMBER, isRemember, 365)
        dispatch(getUserPersonalDetails())
        return { status: invited ? 201 : 200 }
      }
      return { status: 403, message: 'Something is wrong!' }
    } catch (error) {
      console.log('Login Failt! :', error)
      return { status: 403, message: "We can't process your request!" }
    }
  }
}

export const reSignIn = () => {
  return async (dispatch, getState) => {
    const { userInfo } = getState().auth

    if (!userInfo.login_name || !userInfo.password) return false

    const data = { name: userInfo.login_name, password: userInfo.password }

    let res
    if (!isSignin) {
      isSignin = true
      res = await dispatch(userSignIn(data))
    } else {
      return true
    }
    if (res.status === 201 || res.status === 200) return true

    return false
  }
}

export const getWcUsersInfo = (ids) => {
  return async (dispatch, getState) => {
    const { userInfo, users } = getState().auth

    try {
      const response = await getPostServerResponse({ ids: ids, user_id: userInfo.id, token: userInfo.token, cmd: 'WcnFamily.getWcUsersInfo' })
      if (response.error && response.error === 121) {
        const status = await dispatch(reSignIn())
        if (status) return dispatch(getWcUsersInfo(ids))
      }
      response.map(item => users[item.id] = item)
      dispatch(updateAuthState({ users }))
      return response
    } catch (error) {
      console.log(error)
      return []
    }
  }
}

export const changeUserProfile = (request) => {
  return async (dispatch, getState) => {
    const { userInfo } = getState().auth
    request = Object.assign({}, request, { token: (userInfo.token || '') })
    try {
      const response = await getServerResponse(request)
      if (response.error) return 503
      dispatch(getUserPersonalDetails())
      return response
    } catch (error) {
      return 503
    }
  }
}

export const logoutUser = () => {
  return (dispatch) => {
    if (window.wsConnection) window.wsConnection.close(3000)
    if (!global.isNative) deleteCookie(global.IS_REMEMBER)
    localStorage(4)
    dispatch({ type: action.USER_LOGOUT })
    dispatch({ type: action.INITIALIZE_SETTINGS })
  }
}

// [#213 WcnUser1.getRegisterVideo] for welcome screen video
export const getRegisterVideo = () => {
  return async (dispatch) => {
    try {
      const response = await getServerResponse({ cmd: 'WcnUser1.getRegisterVideo' })
      dispatch({
        type: action.WELCOME_VIDEO_URL,
        videoUrl: `https://${global.main_server + response.video}`,
        image: `https://${global.main_server + response.image}`
      })
    } catch (error) {
      exceptionHandler('getRegisterVideo', error)
    }
  }
}

// [#219 WcnVillageRank.getTopRank] The ranking of village battle.
export const getTopRank = () => {
  return async (dispatch, getState) => {
    const { userInfo } = getState().auth
    try {
      const response = await getServerResponse({
        cmd: 'WcnVillageRank.getTopRank',
        token: userInfo.token,
        user_id: userInfo.id
      })
      dispatch({
        type: action.VILLAGE_BATTLE_RANK,
        battle_rank: response
      })
    } catch (error) {
      exceptionHandler('getTopRank', error)
    }
  }
}

// #238 User1.loginByFaceBook
export function loginByFaceBook (request) {
  return async (dispatch, getState) => {
    const { invitedUser, isRemember } = getState().auth
    try {
      const { APP_NAME, APP_PLATFORM } = global
      const response = await getServerResponse({
        cmd: 'User1.loginByFaceBook',
        app: APP_NAME,
        platform: APP_PLATFORM(),
        ...request
      })

      if (response.code === 200) {
        const userInfo = response
        dispatch({ type: Number(userInfo.we_switch) === 1 ? action.IS_ENGLISH_ENABLE : action.IS_ENGLISH_DISABLE })
        if (invitedUser && invitedUser !== 404) {
          if (invitedUser.family_name || invitedUser.role_type) {
            const invitation = {
              cmd: 'WoogiConnectIdentity.joinFamily',
              user_id: userInfo.id,
              identity: invitedUser.role_type,
              family_name: invitedUser.family_name
            }
            await getServerResponse(invitation)
          }
        }
        localStorage(1, global.USERINFO, userInfo)
        dispatch({
          type: action.SET_LOGIN_USER,
          payload: userInfo
        })
        if (isRemember && !global.isNative) setCookie(global.IS_REMEMBER, isRemember, 365)
        dispatch(getUserPersonalDetails())
        return { status: 200 }
      } else {
        return { status: 403 }
      }
    } catch (error) {
      console.log('loginByFaceBook', error)
      return { status: 403 }
    }
  }
}

// login with apple
export const userAppleSignIn = (request) => {
  return async (dispatch, getState) => {
    const { invitedUser, isRemember } = getState().auth
    try {
      const { APP_NAME, APP_PLATFORM } = global
      const response = await getServerResponse({
        cmd: 'User1.loginByApple',
        app: APP_NAME,
        platform: APP_PLATFORM(),
        ...request
      })
      console.log(response)
      if (response.code === 200) {
        const userInfo = response
        dispatch({ type: Number(userInfo.we_switch) === 1 ? action.IS_ENGLISH_ENABLE : action.IS_ENGLISH_DISABLE })
        if (invitedUser && invitedUser !== 404) {
          if (invitedUser.family_name || invitedUser.role_type) {
            const invitation = {
              cmd: 'WoogiConnectIdentity.joinFamily',
              user_id: userInfo.id,
              identity: invitedUser.role_type,
              family_name: invitedUser.family_name
            }
            await getServerResponse(invitation)
          }
        }
        localStorage(1, global.USERINFO, userInfo)
        dispatch({
          type: action.SET_LOGIN_USER,
          payload: userInfo
        })
        if (isRemember && !global.isNative) setCookie(global.IS_REMEMBER, isRemember, 365)
        dispatch(getUserPersonalDetails())
        return { status: 200 }
      } else {
        return { status: 403, message: 'Opps! Something is wrong' }
      }
    } catch (error) {
      console.log('loginByFaceBook', error)
      return { status: 403, message: 'Opps! Something is wrong' }
    }
  }
}
